import { TStore } from "redux/reducer";

export const selectStatisticsState = (state: TStore) => state.statistics;
